angular.module("app").filter("dateFormat", ['$filter', function ($filter) {
    var isDateColumn = {
        date: true,
        start_date: true,
        end_date: true,
        changed_at: true,
        created_at: true
    };
    return function (cellValue, cellName, row) {
        if (isDateColumn[cellName]) {
            if (!cellValue && cellName !== 'changed_at') {
                return "";
            }
            var applyValue = (cellValue === null && cellName === 'changed_at')?row['created_at']: cellValue;
            return $filter("convertDateToUserTimezone")(applyValue, null, 'DD-MM-YYYY hh:mm A');
        }
        return cellValue;
    }
}]);
